<div class="project-offers-details">
  <div class="back-nav-row">
    <button
      type="button"
      class="btn back-nav-button"
      (click)="goToIncomingList()"
    >
      <span class="fas fa-chevron-left"></span>
      {{ "projectOffers.backToProjects" | translate }}
    </button>
  </div>

  <div class="page-header-row">
    <h2 class="page-title">
      {{ "projectOffers.manageIncomingOffersTitle" | translate }}
    </h2>
    <div class="project-name">
      {{ projectName() || projectId() }}
    </div>
  </div>

  @if (projectId()) {
    @if (loading()) {
      <div class="loading-state">
        {{ "projectOffers.loadingIncomingOffers" | translate }}
      </div>
    } @else if (offers().length === 0) {
      <div class="empty-state">
        {{ "projectOffers.emptyIncomingOffers" | translate }}
      </div>
    } @else {
      <app-investments-readonly-table
        [investments]="offers()"
        [loading]="loading()"
        [showSearch]="false"
        [titleKey]="'projectOffers.manageIncomingOffersTitle'"
      ></app-investments-readonly-table>
    }
  } @else {
    <div class="alert alert-warning mb-0">
      {{ "projectOffers.missingProjectId" | translate }}
    </div>
  }
</div>
